import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import { Steps } from 'antd';
import '../studiesPage/studyPage.css'
import { Typography } from '@mui/material';
import { Link } from 'react-router-dom';


const { Step } = Steps;

const MyStudyCard = () => {

  return (
    <>
    <div className='p-3'>
    <Typography sx={{ color: '#169a8f', fontWeight: '600', fontFamily: 'monospace', marginBottom: '20px' }} variant="h4" gutterBottom>
                        My Studies
                    </Typography>
    <div >
    <Card>
      <Card.Body>
        <Row>
          <Col>
            <h6>Study Code</h6>
            <Link style={{ textDecoration: "none" }} to={`/myStudyForm`}>
                        <p>Hassm Study</p>
                      </Link>
          </Col>
          <Col>
            <h6>Study Title</h6>
            <p>Sample Study</p>
          </Col>
          <Col>
            <h6>Sponsor/CRO</h6>
            <p>Sample Sponsor</p>
          </Col>
          <Col>
            <h6>Active Date</h6>
            <p>01/01/2024</p>
          </Col>
          <Col>
            <h6>Recent Activity</h6>
            <p>Some recent</p>
          </Col>
          <Col>
            <h6>Study Manager</h6>
            <p>John Doe</p>
          </Col>
          <Col>
            <h6>PI</h6>
            <p>Hassam</p>
          </Col>
          <Col>
            <h6>Status</h6>
            <p>Active</p>
          </Col>
          <Col>
            <h6>Accepted</h6>
            <p>Yes</p>
          </Col>
         
        </Row>
      </Card.Body>
      <Card.Footer>
        <Row>
          <Col>
            <Steps current={0} className="custom-steps">
              <Step title="SMO"  />
              <Step title="CDA" />
              <Step title="Protocol/FQ" />
              <Step title="PSSV" />
              <Step title="Budget/CTA" />
              <Step title="SIV" />
              <Step title="Invoicing" />

            </Steps>
          </Col>
        </Row>
      </Card.Footer>
    </Card>
    </div>
    </div>
    </>
  );
};

export default MyStudyCard;
